module.exports = __webpack_public_path__ + "img/my_build_edit-attributes@2x.fa253e69.jpg";